module.exports = __webpack_public_path__ + "img/hands-helping.aa6b601.svg";